/**
 * @fileoverview gRPC-Web generated client stub for reorgpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.reorgpb = require('./merger_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.MergerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.MergerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListMergerRequest,
 *   !proto.reorgpb.ListMergerResponse>}
 */
const methodDescriptor_MergerService_ListMerger = new grpc.web.MethodDescriptor(
  '/reorgpb.MergerService/ListMerger',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListMergerRequest,
  proto.reorgpb.ListMergerResponse,
  /**
   * @param {!proto.reorgpb.ListMergerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListMergerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.ListMergerRequest,
 *   !proto.reorgpb.ListMergerResponse>}
 */
const methodInfo_MergerService_ListMerger = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.ListMergerResponse,
  /**
   * @param {!proto.reorgpb.ListMergerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListMergerResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListMergerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.ListMergerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListMergerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.MergerServiceClient.prototype.listMerger =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.MergerService/ListMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_ListMerger,
      callback);
};


/**
 * @param {!proto.reorgpb.ListMergerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListMergerResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.MergerServicePromiseClient.prototype.listMerger =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.MergerService/ListMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_ListMerger);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Merger,
 *   !proto.reorgpb.CreateMergerResponse>}
 */
const methodDescriptor_MergerService_CreateMerger = new grpc.web.MethodDescriptor(
  '/reorgpb.MergerService/CreateMerger',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Merger,
  proto.reorgpb.CreateMergerResponse,
  /**
   * @param {!proto.reorgpb.Merger} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.CreateMergerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Merger,
 *   !proto.reorgpb.CreateMergerResponse>}
 */
const methodInfo_MergerService_CreateMerger = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.CreateMergerResponse,
  /**
   * @param {!proto.reorgpb.Merger} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.CreateMergerResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Merger} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.CreateMergerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.CreateMergerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.MergerServiceClient.prototype.createMerger =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.MergerService/CreateMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_CreateMerger,
      callback);
};


/**
 * @param {!proto.reorgpb.Merger} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.CreateMergerResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.MergerServicePromiseClient.prototype.createMerger =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.MergerService/CreateMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_CreateMerger);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Merger,
 *   !proto.reorgpb.UpdateMergerResponse>}
 */
const methodDescriptor_MergerService_UpdateMerger = new grpc.web.MethodDescriptor(
  '/reorgpb.MergerService/UpdateMerger',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Merger,
  proto.reorgpb.UpdateMergerResponse,
  /**
   * @param {!proto.reorgpb.Merger} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.UpdateMergerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Merger,
 *   !proto.reorgpb.UpdateMergerResponse>}
 */
const methodInfo_MergerService_UpdateMerger = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.UpdateMergerResponse,
  /**
   * @param {!proto.reorgpb.Merger} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.UpdateMergerResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Merger} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.UpdateMergerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.UpdateMergerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.MergerServiceClient.prototype.updateMerger =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.MergerService/UpdateMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_UpdateMerger,
      callback);
};


/**
 * @param {!proto.reorgpb.Merger} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.UpdateMergerResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.MergerServicePromiseClient.prototype.updateMerger =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.MergerService/UpdateMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_UpdateMerger);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Merger,
 *   !proto.reorgpb.DeleteMergerResponse>}
 */
const methodDescriptor_MergerService_DeleteMerger = new grpc.web.MethodDescriptor(
  '/reorgpb.MergerService/DeleteMerger',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Merger,
  proto.reorgpb.DeleteMergerResponse,
  /**
   * @param {!proto.reorgpb.Merger} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.DeleteMergerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Merger,
 *   !proto.reorgpb.DeleteMergerResponse>}
 */
const methodInfo_MergerService_DeleteMerger = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.DeleteMergerResponse,
  /**
   * @param {!proto.reorgpb.Merger} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.DeleteMergerResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Merger} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.DeleteMergerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.DeleteMergerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.MergerServiceClient.prototype.deleteMerger =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.MergerService/DeleteMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_DeleteMerger,
      callback);
};


/**
 * @param {!proto.reorgpb.Merger} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.DeleteMergerResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.MergerServicePromiseClient.prototype.deleteMerger =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.MergerService/DeleteMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_DeleteMerger);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListMergerRequest,
 *   !proto.reorgpb.ListMergerResponse>}
 */
const methodDescriptor_MergerService_MovePageMerger = new grpc.web.MethodDescriptor(
  '/reorgpb.MergerService/MovePageMerger',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListMergerRequest,
  proto.reorgpb.ListMergerResponse,
  /**
   * @param {!proto.reorgpb.ListMergerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListMergerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.ListMergerRequest,
 *   !proto.reorgpb.ListMergerResponse>}
 */
const methodInfo_MergerService_MovePageMerger = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.ListMergerResponse,
  /**
   * @param {!proto.reorgpb.ListMergerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListMergerResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListMergerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.ListMergerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListMergerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.MergerServiceClient.prototype.movePageMerger =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.MergerService/MovePageMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_MovePageMerger,
      callback);
};


/**
 * @param {!proto.reorgpb.ListMergerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListMergerResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.MergerServicePromiseClient.prototype.movePageMerger =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.MergerService/MovePageMerger',
      request,
      metadata || {},
      methodDescriptor_MergerService_MovePageMerger);
};


module.exports = proto.reorgpb;

